import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Container from "@material-ui/core/Container";

import StudentPoll from "./StudentPoll";
import StudentCategories from "./StudentCategories";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  mainPage: (props) => ({
    zIndex: 0,
    marginLeft: props.userMenuOpen ? 260 : 0,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }),
});

function StudentPolls(props) {
  const [showStudentCategories, setShowStudentCategories] = React.useState(false);

  React.useEffect(() => {
  
    if (
      props.match.params?.courseID == props.course?.courseID &&
      !props.account.accountEmail &&
      props.course?.anonChooseCategories && 
      !(
        Object.keys(props.studentCategories).length ===
        Object.keys(props.course.courseCategories).length
      )
    ) {
      setShowStudentCategories(true);
    }
  }, [props.match.params.courseID, props.match.params.pollID, props.course.anonChooseCategories]);

  let mobile = props.width === "sm" || props.width === "xs";
  function returnHome(){
    let route = "/student/"
    props.history.push(route);
    if (mobile) {
      props.openCtl(false);
    }
  }
  return (
    <div className={mobile ? null : props.classes.mainPage}>
      <div className={props.classes.appBarSpacer} />

      {mobile ? (
        <StudentPoll
          account={props.account}
          session={props.session}
          poll={props.poll}
          course={props.course}
          vote={props.vote}
          setVote={(choice) => {
            const data = {
              choice: choice,
              pollID: props.poll.pollID,
            };
            props.setVote(data);
          }}
          live={props.live}
          showDisplay={props.showDisplay}
          screenshotURL={props.screenshotURL}
          screenshotEn={props.screenshotEn}
          handleStudentGeolocation={props.handleStudentGeolocation}
          handleEndStudentGeolocation={props.handleEndStudentGeolocation}
          studentLocation={props.studentLocation}
          loadingStudentLocation={props.loadingStudentLocation}
          refreshSessionListen={props.refreshSessionListen}
          unselect = {()=>returnHome()}
        />
      ) : (
        <Container maxWidth="md">
          <StudentPoll
            account={props.account}
            session={props.session}
            poll={props.poll}
            course={props.course}
            vote={props.vote}
            setVote={(choice) => {
              const data = {
                choice: choice,
                pollID: props.poll.pollID,
              };
              props.setVote(data);
            }}
            live={props.live}
            showDisplay={props.showDisplay}
            screenshotURL={props.screenshotURL}
            screenshotEn={props.screenshotEn}
            handleStudentGeolocation={props.handleStudentGeolocation}
            handleEndStudentGeolocation={props.handleEndStudentGeolocation}
            studentLocation={props.studentLocation}
            loadingStudentLocation={props.loadingStudentLocation}
            refreshSessionListen={props.refreshSessionListen}
            unselect = {()=>returnHome()}
          />
        </Container>
      )}
      
        <StudentCategories
          open={showStudentCategories}
          openCtl={(open) => {
            setShowStudentCategories(open);
          }}
          course={props.course}
          studentID={props.account.accountEmail}
          studentCategories={props.studentCategories}
          updateStudentCategories={(newCategories) => props.updateStudentCategories(newCategories)}
        />
      
    </div>
  );
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(withStyles(styles, { withTheme: true })(withWidth()(StudentPolls)))
);
